import { render, staticRenderFns } from "./UserSearch.vue?vue&type=template&id=6d88855a&scoped=true&"
import script from "./UserSearch.vue?vue&type=script&lang=ts&"
export * from "./UserSearch.vue?vue&type=script&lang=ts&"
import style0 from "./UserSearch.vue?vue&type=style&index=0&id=6d88855a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d88855a",
  null
  
)

export default component.exports